import React, { useContext } from 'react';
import { IconProps } from './iconProps';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';
import cx from 'classnames';

export default function IconSadFace({
  onClick,
  isAutoscallable = true,
  sizeKey = '38x38',
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      className={cx('icon IconSadFace', { 'icon-disabled': !onClick })}
      onClick={onClick}
      width={w}
      height={h}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40">
        <rect width="40" height="40" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_106_1434)">
        <path
          d="M25.8335 18.3335C26.5279 18.3335 27.1182 18.0904 27.6043 17.6043C28.0904 17.1182 28.3335 16.5279 28.3335 15.8335C28.3335 15.1391 28.0904 14.5488 27.6043 14.0627C27.1182 13.5766 26.5279 13.3335 25.8335 13.3335C25.1391 13.3335 24.5488 13.5766 24.0627 14.0627C23.5766 14.5488 23.3335 15.1391 23.3335 15.8335C23.3335 16.5279 23.5766 17.1182 24.0627 17.6043C24.5488 18.0904 25.1391 18.3335 25.8335 18.3335ZM14.1668 18.3335C14.8613 18.3335 15.4516 18.0904 15.9377 17.6043C16.4238 17.1182 16.6668 16.5279 16.6668 15.8335C16.6668 15.1391 16.4238 14.5488 15.9377 14.0627C15.4516 13.5766 14.8613 13.3335 14.1668 13.3335C13.4724 13.3335 12.8821 13.5766 12.396 14.0627C11.9099 14.5488 11.6668 15.1391 11.6668 15.8335C11.6668 16.5279 11.9099 17.1182 12.396 17.6043C12.8821 18.0904 13.4724 18.3335 14.1668 18.3335ZM20.0002 22.5002C18.1113 22.5002 16.396 23.0349 14.8543 24.1043C13.3127 25.1738 12.1946 26.5835 11.5002 28.3335H14.2502C14.8613 27.3057 15.6738 26.4932 16.6877 25.896C17.7016 25.2988 18.8057 25.0002 20.0002 25.0002C21.1946 25.0002 22.2988 25.2988 23.3127 25.896C24.3266 26.4932 25.1391 27.3057 25.7502 28.3335H28.5002C27.8057 26.5835 26.6877 25.1738 25.146 24.1043C23.6043 23.0349 21.8891 22.5002 20.0002 22.5002ZM20.0002 36.6668C17.6946 36.6668 15.5279 36.2293 13.5002 35.3543C11.4724 34.4793 9.7085 33.2918 8.2085 31.7918C6.7085 30.2918 5.521 28.5279 4.646 26.5002C3.771 24.4724 3.3335 22.3057 3.3335 20.0002C3.3335 17.6946 3.771 15.5279 4.646 13.5002C5.521 11.4724 6.7085 9.7085 8.2085 8.2085C9.7085 6.7085 11.4724 5.521 13.5002 4.646C15.5279 3.771 17.6946 3.3335 20.0002 3.3335C22.3057 3.3335 24.4724 3.771 26.5002 4.646C28.5279 5.521 30.2918 6.7085 31.7918 8.2085C33.2918 9.7085 34.4793 11.4724 35.3543 13.5002C36.2293 15.5279 36.6668 17.6946 36.6668 20.0002C36.6668 22.3057 36.2293 24.4724 35.3543 26.5002C34.4793 28.5279 33.2918 30.2918 31.7918 31.7918C30.2918 33.2918 28.5279 34.4793 26.5002 35.3543C24.4724 36.2293 22.3057 36.6668 20.0002 36.6668ZM20.0002 33.3335C23.7224 33.3335 26.8752 32.0418 29.4585 29.4585C32.0418 26.8752 33.3335 23.7224 33.3335 20.0002C33.3335 16.2779 32.0418 13.1252 29.4585 10.5418C26.8752 7.9585 23.7224 6.66683 20.0002 6.66683C16.2779 6.66683 13.1252 7.9585 10.5418 10.5418C7.9585 13.1252 6.66683 16.2779 6.66683 20.0002C6.66683 23.7224 7.9585 26.8752 10.5418 29.4585C13.1252 32.0418 16.2779 33.3335 20.0002 33.3335Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
